<script>
    // @ts-nocheck
    import {
        Button,
        Typography,
        InputFile,
        Row,
        Column,
        InputText,
    } from '$lib/components/UI'
    import {
        TrashOutline,
        ChevronFordwareOutline,
        AddOutline,
        PencilSharp,
        TrashSharp,
        SaveSharp,
    } from '$lib/components/Icons'
    import { fade, scale } from 'svelte/transition'
    import CubiertaSelector from './CubiertaSelector.svelte'
    import Edit from '$lib/components/Icons/custom/Edit.svelte'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import InputPrice from './InputPrice.svelte'
    import Select from '$lib/components/UI/Select32.svelte'
    import dictionaries from '../../stores/dictionaries'
    import { DynamicDict } from '$lib/stores/dynamicDict'
    import createDataStore from '../../stores/datastore'
    import { createEventDispatcher } from 'svelte'
    import { currencyFormatter, validateEmail, validarNoNull, validarImporte, stringSimilarity } from '$lib/utils'
    import { API_URL } from '$lib/conf'
    import { get } from 'svelte/store'
    import ChevronBackOutline from '$lib/components/Icons/ChevronBackOutline.svelte'
    import { InformacionLaboral } from '$lib/components/forms'
    
    export let value = []
    export let edit = false
    export let valid = true
    export let editing = false
    
    let editMode = false
    let marcas = new DynamicDict('Licitacion - Atributos Neumaticos'), modelos, medidas
    
    const dispatch = createEventDispatcher()

    function getId(item) {
        return crypto.randomUUID()
        //`${item.categoria}_${item.producto}_${item?.descripcion}`
    }

    const materialesLlantas = [
        {
            label: 'Acero',
            value: '1',
        },
        {
            label: 'Aleación',
            value: '2',
        },
    ]

    const bestMatch = (txt, options) => {
        let _options = Array.isArray(options) ? options : Object.entries(options).reduce((acc, [label, value]) => {
            acc.push({ label, value })
            return acc
        }, [])
        let optionsWithScore = _options.map((i) => [
            stringSimilarity(txt, i.label),
            i,
        ])
        optionsWithScore.sort((a, b) => b[0] - a[0])
        return optionsWithScore?.at(0)?.at(1)
    }

    const itemsSolver = async (item) => {
        // Resolve Rueda
        if (/^3_(51|9|10|11|12|13)$/.test(item.producto)) {
            let match = /(?<brand>[\w\s]+)\W*\s*(?<model>[\w\s]+)\W*\s*(?<size>.*)/gm.exec(item.descripcion)
            let _modelos, _medidas
            if(match) {
                console.log(match.groups)
                if (!item.marca) {
                    item.marca = await marcas.fetch().then(r => {
                        return bestMatch(match.groups.brand, r)?.value
                    })
                }
                console.log({item})
                if(item.marca && !item.modelo) {
                    _modelos = marcas.sub(item.marca)
                    item.modelo = await _modelos.fetch().then(r => {
                        console.log({st: 2, url: _modelos.url, r})
                        return bestMatch(match.groups.model, r)?.value
                    })
                }
                console.log({item})
                if(item.modelo && _modelos && !item.medida) {
                    _medidas = _modelos.sub(item.modelo)
                    item.medida = await _medidas.fetch().then(r => {
                        console.log({st: 3, url: _medidas.url, r})
                        return bestMatch(match.groups.size, r)?.value
                    })
                }
                console.log({item})
            }
        } else if(/^3_5(0|2)$/.test(item.producto)) {
            let options = bestMatch(item.descripcion, materialesLlantas)
            item.material = options?.value
        }
        console.log({item})
        if(!edit) item.precio_unitario = 0
        item.total = item.precio_unitario * item.cantidad
        return item
    }

    let initialValue = structuredClone(value).map((i) => itemsSolver({
        ...i,
        id: i.id || getId(i),
    }))
    Promise.all(initialValue).then(r => {
        console.log({rere: r})
        $itemsStore = r
    })
    let itemsStore = createDataStore([], getId)
    let loadPerceptions = false
    let itemForm = {}
    let schema = {
        // categoria: {
        //     label: 'Categoría',
        //     render: (v) => $dictionaries?.lic_items_polaris.find((i) => i.value === v)?.label,
        // },
        producto: {
            render: (v) => _productos.find((i) => i.value === v)?.label,
        },
        descripcion: { label: 'Descripción' },
        cantidad: {},
        precio_unitario: {
            render: (n) => currencyFormatter({ n, lang: 'es-AR', type: 'ARS' }),
        },
        total: {
            render: (n) => currencyFormatter({ n, lang: 'es-AR', type: 'ARS' }),
        },
        '': ''
    }

    function updateItem(item) {
        let { id, ...data } = item
        itemsStore.update(id, data)
        editMode = false
        itemForm = item
        clearForm()
    }

    function addItem(item) {
        itemsStore.add(item)
        editMode = false
        clearForm()
    }

    function submitItem() {
        if(currentItem === undefined) { return null }
        if (
            itemForm.categoria == '3' &&
            /^3_(51|9|10|11|12|13)$/.test(itemForm.producto)
        ) {
            itemForm.marca = currentItem.marca || ''
            itemForm.modelo = currentItem.modelo || ''
            itemForm.medida = currentItem.medida || ''
            itemForm.descripcion = currentItem.descripcion || ''
        } else if (
            itemForm.categoria == '3' &&
            /^3_(50|52)$/.test(itemForm.producto)
        ) {
            let materialLabel = materialesLlantas?.find(
                (item) => item.value == currentItem.material
            )?.label
            itemForm.material = currentItem.material || ''
            itemForm.descripcion = `${productLabel} - ${materialLabel}`
        } else {
            itemForm.descripcion = currentItem?.descripcion || itemForm.descripcion
        }
        // else {
            //     if(!itemForm.descripcion.includes(productLabel)) itemForm.descripcion = `${productLabel} - ${itemForm.descripcion}`
            // }
        itemForm.total = itemForm.precio_unitario * itemForm.cantidad
        if (editMode) {
            updateItem(itemForm)
        } else {
            addItem(itemForm)
        }
        currentItem = undefined
    }

    function clearForm() {
        itemForm = {}
        editMode = false
        currentItem = undefined
    }

    async function selectItem(item) {
        currentItem = structuredClone(item)
        itemForm = structuredClone(item)
        for (let [k, v] of Object.entries(item)) {
            itemForm[k] = v
        }
    }

    /* Fix */
    setTimeout(() => {
        itemsStore.forceRefresh()
    }, 500)

    let currentItem

    $: validations = {
        categoria: validarNoNull,
        producto: validarNoNull,
        marca: (v) =>
            itemForm.categoria == '3' &&
            /^3_(51|9|10|11|12|13)$/.test(itemForm.producto)
                ? validarNoNull(v)
                : true,
        modelo: (v) =>
            itemForm.categoria == '3' &&
            /^3_(51|9|10|11|12|13)$/.test(itemForm.producto) &&
            itemForm.marca
                ? validarNoNull(v)
                : true,
        medida: (v) =>
            itemForm.categoria == '3' &&
            /^3_(51|9|10|11|12|13)$/.test(itemForm.producto) &&
            itemForm.modelo
                ? validarNoNull(v)
                : true,
        descripcion: validarNoNull,
        cantidad: (c) => {
            return (
                /\d{1,3}/.test(c) &&
                parseInt(c) > 0 &&
                parseInt(c) <= parseInt(itemForm.maxItems)
            )
        },
        precio_unitario: (p) => parseFloat(p)>0 && p !== null && validarImporte(p),
        material: (v) =>
            itemForm.categoria == '3' && /^3_(50|52)$/.test(itemForm.producto)
                ? validarNoNull(v)
                : true,
    }

    $: fieldValidations = Object.fromEntries(
        Object.entries(validations).map(([k, f]) => [k, f(itemForm[k])])
    )
    const getProductLabel = v => $dictionaries?.lic_items_polaris.find((i) => i.value === v)?.label || ''
    $: value = $itemsStore
    $: productLabel = $dictionaries?.lic_items_polaris.find((i) => i.value === currentItem?.producto)?.label || 'Producto'
    $: valid = validElement
    
    function adjustWidth(node) {
        const setWidth = (ele) => {
            ele.style.width = 42 + (ele.value?.length || 0) * 10 + 'px'
        }
        setWidth(node)
        const handleInput = (event) => { setWidth(event.target) }
        document.addEventListener('input', handleInput, true)
        return {
            destroy() { document.removeEventListener('input', handleInput, true) }
        }
    }
    function setInitialValue(node, val) {
        node.value = val
        const handleInput = ele => {
            if(ele.target.value){
                ele.target.value = ele.target.value.split('').filter(c => /[\d\.\,]/ig.test(c)).join('')
            }
        }
        node.addEventListener('input', handleInput, true)
        return {
            destroy() { document.removeEventListener('input', handleInput, true) }
        }
    }
    $: editing = editMode
    let validElement = false
    const priceCaster = {
        format(txt) {
            let rgx = /(?<!\d)(?<integer>\d{1,3}(?:[.,\s]?\d{3})*)?(?:[.,](?<decimal>\d+))?(?!\d)/g
            let fixedText = txt ? txt?.split('').filter(c => c.match(/[\d\.\,]/i)).join('') || '0' : null
            let match = fixedText ? rgx.exec(fixedText) : null
            if(match) {
                let {integer, decimal} = match.groups
                integer = integer ? integer.replace(/\.|\,/g, '') : '0'
                let ret =  integer + (decimal && decimal !== '0' ? '.' + decimal : '')
                return ret
            }
            return '0'
        },
        input(txt) {
            if(txt) {
                return parseFloat(this.format(txt))
            }
            return 0
        },      
        output(num) {
            let formatter = new Intl.NumberFormat("es-AR", {minimumFractionDigits: 2, maximumFractionDigits: 2, currency: "ARS" })
            return typeof num == 'number' ? formatter.format(num) || '0,00' : '0,00'
        },
        activator(txt) {
            const patterns = [
                /^\d+([.,]\d+)?$/,                        // 1234.56 or 1234,56
                /^\d{1,3}([.,]\d{3})+([.,]\d+)?$/,        // 1.234,56 or 1,234.56 or 1.234.567,89
            ];
            return patterns.some(rx => rx.test(txt));
        },
        type(txt, func) {
            if(this.activator(txt)) {
                return func(this.input(txt))
            }
        }
    }
</script>

{#if currentItem || editMode}
    <div>
        <Typography type="h4">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span
                style="cursor: pointer; margin: 0 10px 10px 0; display:flex; align-items: center;"
                on:click={() => {
                    editMode = false;
                    currentItem = undefined;
                    clearForm()
                }}
            >
             <ChevronBackOutline size={28}/>
             {productLabel}
            </span>
        </Typography>
        {#key value || editMode}
            {#if currentItem.categoria == '3' && /^3_(51|9|10|11|12|13)$/.test(currentItem.producto)}
                <Row>
                    <CubiertaSelector
                        bind:marca={currentItem.marca}
                        bind:modelo={currentItem.modelo}
                        bind:medida={currentItem.medida}
                        bind:descripcion={currentItem.descripcion}
                        bind:valid={validElement}
                        dict={marcas}
                    />
                </Row>
            {:else if itemForm.categoria == '3' && ['3_50', '3_52'].includes(itemForm.producto)}
                <Select
                    required
                    validation={validarNoNull}
                    label="Material"
                    bind:valid={validElement}
                    options={materialesLlantas}
                    bind:value={currentItem.material}
                />
            {:else}
                <InputText
                    required
                    validation={validations.descripcion}
                    label="Descripcion"
                    bind:value={currentItem.descripcion}
                />
            {/if}
            <Row>
                <Button
                    type="other"
                    size="small"
                    label="Cancelar"
                    on:click={() => {
                        clearForm()
                    }}
                />
                <Button
                    size="small"
                    disabled={!validElement}
                    label={!editMode ? 'Agregar item' : 'Guardar'}
                    on:click={submitItem}
                >
                    {#if editMode}
                        <SaveSharp color="white" size={20} />
                    {:else}
                        <AddOutline color="white" size={20} />
                    {/if}
                </Button>
            </Row>
        {/key}
    </div>
{:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <Datatable bind:data={itemsStore} {schema}>
        <svelte:fragment slot="row" let:item>
            <tr style="width: 100%">
                <td>
                    {getProductLabel(item.producto)} 
                </td>
                <td>{item.descripcion}</td>
                <td>{item.cantidad}</td>
                <td class="precio_unitario">
                    <span>
                        <!-- value={priceCaster.output(item.precio_unitario)} -->
                        <!-- use:adjustWidth -->
                        <!-- <input
                            use:setInitialValue={priceCaster.output(item.precio_unitario)}
                            type="text"
                            width="75px"
                            maxlength="14"
                            on:input={e => {
                                priceCaster.type(e.target.value, p => {
                                    let t = p * item.cantidad
                                    itemsStore.update(item.id, { precio_unitario:p, total:t })
                                })
                            }}
                        /> -->
                        <InputPrice
                                value={item.precio_unitario}
                                type={p => {
                                    let t = p * item.cantidad
                                    itemsStore.update(item.id, { precio_unitario:p, total:t })
                                }}
                        />
                    </span>
                </td>
                <td>{currencyFormatter({ n: item.total, lang: 'es-AR', type: 'ARS' })}</td>
                <td>
                    {#if item.categoria == '3' && (/^3_(51|9|10|11|12|13)$/.test(item.producto) || ['3_50', '3_52'].includes(item.producto))}
                        <i
                            style="display: flex;gap: 5px;cursor: pointer; color: #00669E; font-style: normal"
                            on:click={() => {
                                editMode = true
                                selectItem(item)
                            }}
                        >
                            <PencilSharp size={18} title="Editar" />
                            Editar 
                        </i>
                    {/if}
            </td>
            </tr>
        </svelte:fragment>
    </Datatable>
{/if}

<style>
    td.precio_unitario {
        min-width: 95px;
        /* min-width: 50px; */
        /* position: relative;
        width: auto; */
        /* max-width: 50px; */
    }
    /* input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type='text'] {
        width: 135px;
        position: relative;
        outline: none;
        font-family: 'Roboto', sans-serif;
        appearance: none;
        -moz-appearance: textfield;
        font-size: 18px;
        border-style: unset;
        border-bottom: 1.5px solid var(--color-brand-primary-01);
        font-family: 'Roboto', sans-serif;
    } */
</style>
